import people from "../../assets/people.webp";

export default function Section2() {
	return (
		<section className="flex flex-col md:flex-row justify-center items-center gap-10 py-10 px-6 md:px-16">
			<div className="flex-1 text-center md:text-left">
				<h2 className="text-2xl font-bold text-gray-800 mb-4 uppercase">
					Comercializadora Central ent
				</h2>
				<p className="text-gray-800">
					En CENTRAL ENT somos una empresa especializada en la renta de autos,
					camionetas y minivans en Puebla. Satisfacemos todos tus requerimientos
					de movilidad poniendo a tu disposición una amplia variedad de
					vehículos con la capacidad adecuada para ti y tu familia y tu empresa
				</p>
				<p className="text-gray-800">
					Respaldamos a nuestra empresa con la confianza y credibilidad de
					nuestros clientes.
				</p>
			</div>
			<div className="flex-1 flex justify-center">
				<img src={people} alt="guy" className="w-auto h-80" />
			</div>
		</section>
	);
}
